var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-page',{attrs:{"title":"DESPACHOS"}}),_c('card',{attrs:{"title":"Crear despacho","agregar":false}},[(
        _vm.listaTipoImportacion &&
        _vm.listaTipoExportacion &&
        _vm.listaUsuarios &&
        _vm.clientes
      )?_c('form-despacho',{attrs:{"form":_vm.form,"usuarios":_vm.usuarios,"clientes":_vm.clientes,"listaUsuarios":_vm.listaUsuarios,"listaTipoImportacion":_vm.listaTipoImportacion,"listaTipoExportacion":_vm.listaTipoExportacion,"valorGrande":_vm.valorGrande,"submit":_vm.submit,"listaAduanas":_vm.listaAduanas,"listaMediosTransporte":_vm.listaMediosTransporte,"medioTransporte":_vm.medioTransporte}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }